import { useEffect, useRef, useState } from "react";
import "./DemoPage.css";

const BOOKING_URL = "https://calendar.app.google/2K9EBUh8taRBcRi89";
const PHONE = "+4570221990";

const CleanyLogo = () => (
    <svg viewBox="0 0 1000 253" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M890.806 253C886.11 253 881.762 252.62 877.764 251.859C873.829 251.161 870.687 250.337 868.339 249.386L876.336 222.562C881.35 224.021 885.824 224.718 889.759 224.655C893.694 224.591 897.153 223.355 900.136 220.945C903.182 218.599 905.752 214.667 907.847 209.151L910.798 201.256L857.772 52.1105H894.328L928.029 162.448H929.552L963.348 52.1105H1000L941.452 215.904C938.723 223.64 935.106 230.267 930.6 235.784C926.093 241.364 920.572 245.612 914.035 248.529C907.561 251.51 899.818 253 890.806 253Z"
            fill="#2980B9"
        />
        <path
            d="M761.807 112.606V198.212H727.345V52.1105H760.284V76.9363H761.997C765.361 68.7562 770.724 62.2564 778.086 57.4371C785.512 52.6178 794.683 50.2081 805.599 50.2081C815.69 50.2081 824.48 52.3641 831.969 56.6762C839.522 60.9882 845.36 67.2343 849.486 75.4144C853.675 83.5946 855.737 93.5186 855.674 105.186V198.212H821.212V110.513C821.212 100.748 818.673 93.1064 813.596 87.5896C808.582 82.0727 801.632 79.3143 792.747 79.3143C786.718 79.3143 781.355 80.6459 776.658 83.3092C772.025 85.9091 768.376 89.6822 765.71 94.6283C763.108 99.5744 761.807 105.567 761.807 112.606Z"
            fill="#2980B9"
        />
        <path
            d="M631.57 201.161C622.304 201.161 613.958 199.512 606.533 196.214C599.171 192.854 593.332 187.907 589.016 181.376C584.764 174.845 582.638 166.791 582.638 157.216C582.638 148.972 584.161 142.156 587.207 136.766C590.254 131.376 594.411 127.064 599.679 123.83C604.946 120.596 610.88 118.154 617.481 116.505C624.145 114.793 631.031 113.557 638.139 112.796C646.707 111.908 653.657 111.115 658.988 110.418C664.319 109.657 668.19 108.516 670.602 106.994C673.077 105.408 674.315 102.967 674.315 99.6696V99.0989C674.315 91.9333 672.189 86.3847 667.937 82.4532C663.684 78.5216 657.56 76.5559 649.563 76.5559C641.122 76.5559 634.426 78.3948 629.476 82.0727C624.589 85.7506 621.289 90.0943 619.575 95.1039L587.398 90.5382C589.936 81.6605 594.125 74.2413 599.964 68.2806C605.803 62.2564 612.943 57.7542 621.384 54.7738C629.825 51.73 639.155 50.2081 649.373 50.2081C656.417 50.2081 663.43 51.0325 670.412 52.6812C677.393 54.3299 683.771 57.0566 689.547 60.8614C695.322 64.6027 699.955 69.7073 703.446 76.1754C707 82.6434 708.777 90.7285 708.777 100.431V198.212H675.648V178.142H674.505C672.411 182.2 669.46 186.005 665.652 189.556C661.907 193.044 657.179 195.866 651.467 198.022C645.819 200.114 639.186 201.161 631.57 201.161ZM640.519 175.859C647.437 175.859 653.435 174.496 658.512 171.769C663.589 168.979 667.492 165.301 670.221 160.735C673.014 156.17 674.41 151.192 674.41 145.802V128.585C673.331 129.473 671.491 130.298 668.889 131.059C666.35 131.819 663.494 132.485 660.321 133.056C657.147 133.627 654.006 134.134 650.896 134.578C647.786 135.022 645.089 135.402 642.804 135.719C637.663 136.417 633.062 137.558 629 139.144C624.938 140.729 621.733 142.948 619.385 145.802C617.037 148.592 615.862 152.206 615.862 156.645C615.862 162.987 618.179 167.774 622.812 171.008C627.445 174.242 633.347 175.859 640.519 175.859Z"
            fill="#2980B9"
        />
        <path
            d="M511.401 201.065C496.74 201.065 484.079 198.022 473.416 191.934C462.818 185.783 454.662 177.096 448.95 165.872C443.238 154.584 440.382 141.3 440.382 126.017C440.382 110.989 443.238 97.7989 448.95 86.4481C454.726 75.034 462.786 66.1563 473.131 59.8151C483.476 53.4104 495.63 50.2081 509.592 50.2081C518.604 50.2081 527.109 51.6666 535.106 54.5836C543.166 57.4371 550.274 61.876 556.43 67.9001C562.65 73.9243 567.537 81.5971 571.091 90.9187C574.645 100.177 576.422 111.211 576.422 124.02V134.578H456.566V111.369H543.388C543.325 104.774 541.897 98.9086 539.104 93.7722C536.312 88.5724 532.408 84.4824 527.395 81.502C522.444 78.5216 516.669 77.0314 510.068 77.0314C503.023 77.0314 496.835 78.7436 491.504 82.1678C486.173 85.5287 482.016 89.9675 479.033 95.4844C476.114 100.938 474.622 106.93 474.559 113.462V133.722C474.559 142.219 476.114 149.511 479.224 155.599C482.333 161.623 486.681 166.252 492.266 169.486C497.851 172.657 504.388 174.242 511.877 174.242C516.891 174.242 521.429 173.545 525.491 172.15C529.552 170.691 533.075 168.567 536.058 165.777C539.041 162.987 541.294 159.531 542.817 155.409L574.994 159.023C572.963 167.52 569.092 174.94 563.38 181.281C557.731 187.559 550.496 192.441 541.674 195.929C532.853 199.353 522.761 201.065 511.401 201.065Z"
            fill="#2980B9"
        />
        <path d="M427.312 3.41001V198.212H392.85V3.41001H427.312Z" fill="#2980B9" />
        <path
            d="M378.114 69.1366H342.51C341.494 63.3027 339.622 58.1346 336.893 53.6324C334.164 49.0667 330.768 45.1986 326.706 42.028C322.645 38.8574 318.012 36.4794 312.807 34.8941C307.667 33.2454 302.113 32.4211 296.147 32.4211C285.549 32.4211 276.155 35.0843 267.968 40.411C259.781 45.6742 253.371 53.4104 248.738 63.6198C244.105 73.7657 241.788 86.1628 241.788 100.811C241.788 115.713 244.105 128.268 248.738 138.478C253.435 148.624 259.845 156.297 267.968 161.496C276.155 166.633 285.517 169.201 296.052 169.201C301.891 169.201 307.349 168.44 312.426 166.918C317.567 165.333 322.169 163.018 326.23 159.974C330.356 156.931 333.815 153.189 336.607 148.751C339.463 144.312 341.431 139.239 342.51 133.532L378.114 133.722C376.781 142.98 373.894 151.667 369.451 159.784C365.072 167.901 359.328 175.067 352.22 181.281C345.112 187.432 336.798 192.251 327.278 195.739C317.758 199.163 307.191 200.875 295.576 200.875C278.44 200.875 263.145 196.912 249.69 188.985C236.235 181.059 225.636 169.613 217.893 154.648C210.151 139.683 206.279 121.737 206.279 100.811C206.279 79.8216 210.182 61.876 217.989 46.9741C225.795 32.0089 236.426 20.563 249.88 12.6365C263.335 4.70995 278.567 0.746699 295.576 0.746699C306.429 0.746699 316.52 2.26859 325.85 5.31237C335.179 8.35615 343.493 12.8267 350.792 18.724C358.091 24.5579 364.088 31.7235 368.785 40.2207C373.545 48.6545 376.654 58.2932 378.114 69.1366Z"
            fill="#2980B9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.7092 25.7429C59.9882 -8.5809 115.587 -8.58101 149.866 25.7429C184.145 60.0671 184.145 115.74 149.866 150.064L149.782 150.148L103.723 194.476C99.4378 198.594 93.7278 200.894 87.7882 200.891C81.8488 200.888 76.1408 198.583 71.8604 194.46L25.793 150.156L25.7092 150.064C-8.56974 115.74 -8.56974 60.0671 25.7092 25.7429ZM87.7869 33.9537C58.0711 33.9537 33.9822 58.0222 33.9821 87.7126C33.9821 117.403 58.071 141.473 87.7869 141.473C117.503 141.473 141.592 117.403 141.592 87.7126C141.592 58.0223 117.503 33.9538 87.7869 33.9537Z"
            fill="#2980B9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M87.6914 48.1007C89.572 48.1007 91.3069 48.7895 92.6582 50.1565C94.0077 51.5219 94.677 53.2603 94.677 55.1315V84.6472L111.245 94.4051L111.26 94.4148L111.277 94.4245C112.954 95.4425 113.97 96.9371 114.442 98.6894C114.94 100.539 114.689 102.414 113.661 104.061L113.658 104.059C112.361 106.279 110.258 107.519 107.655 107.519C106.406 107.519 105.133 107.228 104.022 106.463L85.2481 95.3764C83.9558 94.908 82.9023 94.0896 82.1023 93.0595C81.1169 91.7904 80.7072 90.3486 80.7071 88.8457V55.1315C80.7072 53.2603 81.375 51.5219 82.7246 50.1565C84.0758 48.7894 85.8108 48.1008 87.6914 48.1007Z"
            fill="#2980B9"
        />
    </svg>
);

const ArrowIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
);

const CheckCircleIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <circle cx="12" cy="12" r="10" />
        <path d="m8 12 3 3 5-6" />
    </svg>
);

const CheckIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        <path d="M20 6 9 17l-5-5" />
    </svg>
);

const USPS = [
    {
        title: "Live-overblik",
        body: "Se hvem der er på job lige nu, hvad der er udført, og hvad der er forsinket.",
        icon: <path d="M3 12h4l3-8 4 16 3-8h4" />,
    },
    {
        title: "Fakturering med ét klik",
        body: "Direkte til e-conomic eller Dinero. Fredagen er ikke længere fakturadag.",
        icon: (
            <>
                <path d="M6 2h9l5 5v15H6z" />
                <path d="M14 2v6h6M9 13h6M9 17h6" />
            </>
        ),
    },
    {
        title: "Korrekt løn hver gang",
        body: "Tid, kørsel og kilometer registreres automatisk fra mobilen.",
        icon: (
            <>
                <rect x="2" y="6" width="20" height="13" rx="2" />
                <circle cx="12" cy="12.5" r="2.5" />
                <path d="M6 10v.01M18 15v.01" />
            </>
        ),
    },
    {
        title: "Styr på nøgler og koder",
        body: "Hver nøgle er koblet til kunde og medarbejder. Vikaren har alt klar.",
        icon: (
            <>
                <circle cx="7.5" cy="15.5" r="4.5" />
                <path d="m10.7 12.3 9.3-9.3M16 7l3 3M14 9l2 2" />
            </>
        ),
    },
    {
        title: "Reklamationer der lukkes",
        body: "Sporet fra modtagelse til lukning, med foto-dokumentation fra opgaven.",
        icon: (
            <>
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                <path d="m9 10 2 2 4-4" />
            </>
        ),
    },
    {
        title: "Dansk og sikkert",
        body: "Dansk team og support. Data hostet i EU og GDPR-compliant.",
        icon: (
            <>
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="m9 12 2 2 4-4" />
            </>
        ),
    },
];

const FAQS = [
    {
        q: "Hvad koster Cleany?",
        a: "Cleany Core starter fra 1.495 kr/md ekskl. moms, og I betaler kun for de moduler, I bruger. I demoen regner vi en pris ud på jeres firma.",
    },
    {
        q: "Skal vi forberede noget til demoen?",
        a: "Nej. Det er en god idé at vide cirka, hvor mange medarbejdere og kunder I har, men det er det hele.",
    },
    {
        q: "Vi bruger Excel i dag. Hvor svært er det at skifte?",
        a: "Vi hjælper med at importere jeres kunder, medarbejdere og lokationer fra Excel, og I får en onboarding-session med en af os. De fleste er i gang på under en uge.",
    },
    {
        q: "Kan Cleany tale sammen med vores økonomisystem?",
        a: "Ja. Cleany integrerer med e-conomic og Dinero, så fakturaer sendes direkte derover.",
    },
    {
        q: "Er der binding?",
        a: "Nej. Ingen binding og fri opsigelse. Og I kan starte med 14 dages gratis prøveperiode.",
    },
    {
        q: "Hvor ligger vores data?",
        a: "Alle data er hostet i certificerede datacentre i EU, krypteret og med daglig backup. Databehandleraftale følger med fra start.",
    },
];

const STEPS = [
    {
        title: "Vi hører om jeres drift",
        body: "Hvor mange medarbejdere, hvilke systemer I bruger i dag, og hvad der driller.",
    },
    {
        title: "I ser Cleany live",
        body: "Kun de moduler, der er relevante for jer. Spørg ind til alt.",
    },
    {
        title: "I får et estimat",
        body: "Hvad Cleany vil koste, og hvor meget tid I kan spare. Beslut bagefter i ro og mag.",
    },
];

const PROMISES = [
    "Live demo af de moduler, der passer til jer",
    "Estimeret tids- og prisbesparelse for jeres firma",
    "Svar på alt. Vi har ingen sælger-script",
    "Vi kontakter jer aldrig uopfordret bagefter",
];

export default function DemoPage() {
    const videoRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [stickyOn, setStickyOn] = useState(false);

    useEffect(() => {
        document.title = "Book en demo af Cleany";

        const setMeta = (name, content) => {
            let el = document.querySelector(`meta[name='${name}']`);
            if (!el) {
                el = document.createElement("meta");
                el.name = name;
                document.head.appendChild(el);
            }
            const prev = el.getAttribute("content");
            el.setAttribute("content", content);
            return () => el.setAttribute("content", prev || "");
        };

        const restoreDesc = setMeta(
            "description",
            "Se på 20 minutter, hvordan Cleany samler planlægning, nøgler, reklamationer, løn og fakturering i jeres rengøringsfirma.",
        );
        const restoreRobots = setMeta("robots", "noindex, nofollow");

        return () => {
            restoreDesc();
            restoreRobots();
        };
    }, []);

    useEffect(() => {
        const check = () => {
            const hero = document.getElementById("demo-hero");
            const fin = document.getElementById("book");
            if (!hero || !fin) return;
            const pastHero = window.scrollY > hero.offsetTop + hero.offsetHeight - 80;
            const finalVisible = fin.getBoundingClientRect().top < window.innerHeight;
            setStickyOn(pastHero && !finalVisible);
        };
        window.addEventListener("scroll", check, { passive: true });
        check();
        return () => window.removeEventListener("scroll", check);
    }, []);

    const startVideo = () => {
        const v = videoRef.current;
        if (!v) return;
        setPlaying(true);
        v.controls = true;
        v.play();
    };

    return (
        <div className="demo-lp" data-testid="demo-landing-page">
            <header className="top">
                <div className="wrap">
                    <a className="logo" href="/demo" aria-label="Cleany" data-testid="demo-logo">
                        <CleanyLogo />
                    </a>
                    <div className="top-r">
                        <a className="tel" href={`tel:${PHONE}`} data-testid="demo-phone-top">
                            +45 70 22 19 90
                        </a>
                        <a
                            className="btn sm"
                            href={BOOKING_URL}
                            target="_blank"
                            rel="noopener"
                            data-testid="demo-book-top"
                        >
                            Book demo
                        </a>
                    </div>
                </div>
            </header>

            <section className="hero" id="demo-hero">
                <div className="wrap hero-grid">
                    <div className="hero-a">
                        <span className="pill">
                            <i />
                            Til ejere og servicechefer i rengøringsfirmaer
                        </span>
                        <h1>
                            Driftsplatformen <span className="blue">bygget til danske</span>{" "}
                            rengøringsfirmaer.
                        </h1>
                        <p className="lead">
                            Planlægning, nøgler, reklamationer, løn og fakturering samlet ét sted.
                            Se på 20 minutter, hvordan Cleany vil fungere i jeres firma.
                        </p>
                    </div>
                    <div className="hero-b">
                        <div className="cta-row">
                            <a
                                className="btn"
                                href={BOOKING_URL}
                                target="_blank"
                                rel="noopener"
                                data-testid="demo-book-hero"
                            >
                                Book 20 min. demo <ArrowIcon />
                            </a>
                            <span className="cta-note">
                                Eller ring{" "}
                                <a href={`tel:${PHONE}`} data-testid="demo-phone-hero">
                                    +45 70 22 19 90
                                </a>
                            </span>
                        </div>
                        <div className="ticks">
                            <span>
                                <CheckCircleIcon />
                                20 min. med stifteren
                            </span>
                            <span>
                                <CheckCircleIcon />
                                Ingen salgstale
                            </span>
                            <span>
                                <CheckCircleIcon />
                                14 dages gratis prøveperiode
                            </span>
                        </div>
                    </div>
                    <div className="hero-v">
                        <div className={`vsl${playing ? " playing" : ""}`} data-testid="demo-vsl">
                            <video
                                ref={videoRef}
                                poster="/media/cleany-explainer-poster.jpg"
                                preload="metadata"
                                playsInline
                                data-testid="demo-video"
                            >
                                <source src="/media/cleany-explainer-h264.mp4" type="video/mp4" />
                            </video>
                            <button
                                className="play"
                                onClick={startVideo}
                                aria-label="Afspil video"
                                data-testid="demo-video-play"
                            >
                                <span className="pb">
                                    <b>
                                        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                            <path d="M7 4.5v15a1 1 0 0 0 1.5.86l12.5-7.5a1 1 0 0 0 0-1.72L8.5 3.64A1 1 0 0 0 7 4.5z" />
                                        </svg>
                                    </b>
                                    Se Cleany på 60 sek.
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="numbers">
                <div className="wrap">
                    <div className="eyebrow">Konkret værdi</div>
                    <h2>
                        Et rengøringsfirma med 25 medarbejdere sparer{" "}
                        <span>ca. 282.000 kr om året</span> i administration.
                    </h2>
                    <div className="ngrid">
                        <div className="ncard">
                            <div className="num">24 t</div>
                            <p>sparet pr. uge</p>
                            <small>ved 25 medarbejdere</small>
                        </div>
                        <div className="ncard">
                            <div className="num">60%</div>
                            <p>mindre admin-tid</p>
                            <small>på fakturering og rapporter</small>
                        </div>
                        <div className="ncard">
                            <div className="num">282.000 kr</div>
                            <p>sparet pr. år</p>
                            <small>ved 230 kr/t timepris</small>
                        </div>
                    </div>
                    <p className="fine">
                        Beregnet med Cleanys priskalkulator. I demoen regner vi på jeres egne tal.
                    </p>
                </div>
            </section>

            <section className="s">
                <div className="wrap">
                    <div className="s-head">
                        <span className="pill">
                            <i />
                            Det får I
                        </span>
                        <h2>Ét sted til hele driften. Slut med Excel og post-its.</h2>
                        <p>
                            Cleany er bygget til hverdagen i et rengøringsfirma. Ikke et generisk
                            CRM, der skal tilpasses.
                        </p>
                    </div>
                    <div className="ugrid">
                        {USPS.map((u) => (
                            <div className="u" key={u.title}>
                                <div className="ic">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        aria-hidden="true"
                                    >
                                        {u.icon}
                                    </svg>
                                </div>
                                <h3>{u.title}</h3>
                                <p>{u.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="s case">
                <div className="wrap">
                    <div className="s-head c">
                        <span className="pill">
                            <i />
                            Kundecase
                        </span>
                        <h2>Hvad Cleany betyder i hverdagen</h2>
                    </div>
                    <div className="case-card" data-testid="demo-case-card">
                        <div className="case-body">
                            <p className="quote">
                                Jeg har mere ro til at være sammen med mine kollegaer og mine
                                kunder.
                            </p>
                            <p className="who">
                                <b>Annette</b> · Servicechef hos Renommé · 20 år i branchen
                            </p>
                            <div className="cstats">
                                <div className="cs">
                                    <div className="num">
                                        <s>2½ dag</s> 3 t
                                    </div>
                                    <p>til fakturering for en hel måned</p>
                                </div>
                                <div className="cs">
                                    <div className="num">Korrekt</div>
                                    <p>løn til medarbejderne, hver gang</p>
                                </div>
                                <div className="cs">
                                    <div className="num">ca. 25 t</div>
                                    <p>
                                        kontortid pr. uge ved 150 medarbejdere (Annettes vurdering)
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="s">
                <div className="wrap steps-grid">
                    <div>
                        <div className="s-head" style={{ marginBottom: 30 }}>
                            <span className="pill">
                                <i />
                                Demoen
                            </span>
                            <h2>Sådan foregår de 20 minutter</h2>
                            <p>
                                En uforpligtende snak med stifteren. Ingen salgstale, bare en god
                                snak om jeres drift.
                            </p>
                        </div>
                        <div className="steps">
                            {STEPS.map((s, i) => (
                                <div className="step" key={s.title}>
                                    <div className="n">{i + 1}</div>
                                    <div>
                                        <h3>{s.title}</h3>
                                        <p>{s.body}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="promise">
                        <h3>Det får du ud af mødet</h3>
                        <ul>
                            {PROMISES.map((p) => (
                                <li key={p}>
                                    <CheckCircleIcon />
                                    {p}
                                </li>
                            ))}
                        </ul>
                        <a
                            className="btn"
                            href={BOOKING_URL}
                            target="_blank"
                            rel="noopener"
                            data-testid="demo-book-promise"
                        >
                            Book 20 min. demo <ArrowIcon />
                        </a>
                        <div className="founder">
                            <div className="av">C</div>
                            <div>
                                <b style={{ color: "var(--ink)" }}>[Stifterens navn]</b>
                                <br />
                                Stifter af Cleany. Har selv arbejdet i rengøringsbranchen
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="s" style={{ paddingTop: 0 }}>
                <div className="wrap">
                    <div className="s-head c">
                        <h2>Spørgsmål vi ofte får</h2>
                    </div>
                    <div className="faq" data-testid="demo-faq">
                        {FAQS.map((f, i) => (
                            <details key={f.q} open={i === 0} data-testid={`demo-faq-item-${i}`}>
                                <summary>{f.q}</summary>
                                <p>{f.a}</p>
                            </details>
                        ))}
                    </div>
                </div>
            </section>

            <section className="final" id="book">
                <div className="wrap">
                    <h2>
                        Se, hvordan Cleany vil fungere{" "}
                        <span>for jeres rengøringsfirma.</span>
                    </h2>
                    <p>20 minutter med stifteren. I får et konkret bud på, hvad I kan spare.</p>
                    <a
                        className="btn white"
                        href={BOOKING_URL}
                        target="_blank"
                        rel="noopener"
                        data-testid="demo-book-final"
                    >
                        Book 20 min. demo <ArrowIcon />
                    </a>
                    <div className="cta-note">
                        Eller ring{" "}
                        <a href={`tel:${PHONE}`} data-testid="demo-phone-final">
                            +45 70 22 19 90
                        </a>
                    </div>
                    <div className="price-line">
                        <span>
                            <CheckIcon />
                            Fra 1.495 kr/md
                        </span>
                        <span>
                            <CheckIcon />
                            Ingen binding
                        </span>
                        <span>
                            <CheckIcon />
                            14 dages gratis prøveperiode
                        </span>
                    </div>
                </div>
            </section>

            <footer>
                <div className="wrap">
                    <span>© 2026 Cleany.dk · CVR 45 42 27 20 · Strevelinsvej 16, 7000 Fredericia</span>
                    <span>
                        <a href="https://cleany.dk/privatlivspolitik">Privatlivspolitik</a> ·{" "}
                        <a href="https://cleany.dk">cleany.dk</a>
                    </span>
                </div>
            </footer>

            <div
                className={`sticky${stickyOn ? " on" : ""}`}
                data-testid="demo-sticky-bar"
            >
                <a
                    className="btn"
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noopener"
                    data-testid="demo-book-sticky"
                >
                    Book 20 min. demo <ArrowIcon />
                </a>
            </div>
        </div>
    );
}
